const styles = `
  z-index: 9999999;
  color: #fff;
  background: rgba(29, 50, 153, 0.5);
  backdrop-filter: blur(3px);
`;

export default styles;
